import { defineStore } from "pinia"
import { fetchDeviceConfiguration } from "frontcore/utils/communications/configurations"
import { readonly, Ref, ref } from "vue"
import { SkillMatrixConfiguration } from 'frontcore/store/configurations/skillMatrixConfigurationTypes'

interface ProblemTypes {
  JUST_DO_IT: boolean
  SHORT_LOOP: boolean
}

interface ProblemsConfiguration {
  AVAILABLE_PROBLEM_LEVELS: ProblemTypes
  ENABLE_PROBLEM_SUPERVISOR: boolean
  SHOW_PRIORITIES: boolean
}

type AuditSourceEvidenceConfiguration = {
  MANDATORY_NOK_PICTURE: boolean
  MANDATORY_OK_PICTURE: boolean
  MANDATORY_COMMENT: boolean
}

export interface DeviceConfiguration {
  ONLY_CREATOR_CAN_VERIFY_ACTIONS?: boolean
  ONLY_CREATOR_CAN_DELETE_ACTIONS?: boolean
  ENABLE_TM_GROUPS_ALTERING_SCHEDULE?: boolean
  ENABLE_ACTION_EFFECTIVENESS_PARTIALLY?: boolean
  MANDATORY_ISSUE_DESCRIPTION_TO_CLOSE_ACTIONS?: boolean
  MANDATORY_CAUSE_DESCRIPTION_TO_CLOSE_ACTIONS?: boolean
  MANDATORY_EFFECTIVENESS_TO_CLOSE_ACTIONS?: boolean
  PROBLEMS_CONFIGURATION?: ProblemsConfiguration
  SKILL_MATRIX?: SkillMatrixConfiguration
  INCLUDE_PROBLEM_SOLVING?: boolean
  AUDITS_ACTION_EVIDENCES?: Record<string, AuditSourceEvidenceConfiguration>,
  LEAN_CENTER?: {
    GEMBA_WALK?: {
      FACE_TO_FACE?: boolean
    }
  }
  SHOW_IMPROVEMENT_IDEA_MODULE?: boolean
}


export const useDeviceConfigurationStore = defineStore('DeviceConfiguration', () => {
  const internalDeviceConfiguration: Ref<DeviceConfiguration> = ref({})
  const deviceConfiguration = readonly(internalDeviceConfiguration)

  async function loadDeviceConfiguration () {
    internalDeviceConfiguration.value = await fetchDeviceConfiguration() as DeviceConfiguration
  }

  const getAuditActionEvidencesConfigurationFor = (auditSource: string): AuditSourceEvidenceConfiguration | undefined => {
    if (internalDeviceConfiguration.value && Object.keys(internalDeviceConfiguration.value).includes('AUDITS_ACTION_EVIDENCES')) {
      const config = internalDeviceConfiguration.value.AUDITS_ACTION_EVIDENCES
      if (config && Object.keys(config).includes(auditSource)) {
        return config[auditSource]
      }
    }
    return undefined
  }

  return {
    loadDeviceConfiguration,
    deviceConfiguration,
    getAuditActionEvidencesConfigurationFor,
  }
})
